import React from "react";
import { IconCalendar1, IconCircle1 } from "../../../icons/Icon";
import SmuNotificationIcon from "../../../utils/smu-notification-icon/SmuNotificationIcon";

const NtfItem = ({ item }) => {
  return (
    <li className="ntf-item mb-2">
      <div className="icon-section px-2">
        <SmuNotificationIcon color="#FBAB33" />
      </div>
      <div className="detail-section text-truncate ps-2">
        <div className="title text-truncate">{item.title}</div>
        <div className="date text-truncate">
          <IconCalendar1 color="#748a9d" />
          <span className="ms-1">
            {item.start} | {item.start}
          </span>
        </div>
      </div>
      {/* <div className="duration-section px-2">
        <div className="duration me-3">1h</div>
        <IconCircle1 color="#E31C19" />
      </div> */}
    </li>
  );
};

export default NtfItem;
